export default "__VITE_ASSET__COaFwZpr__"